import { render, staticRenderFns } from "./SpaceSingle.vue?vue&type=template&id=0808ef56&scoped=true&"
import script from "./SpaceSingle.vue?vue&type=script&lang=js&"
export * from "./SpaceSingle.vue?vue&type=script&lang=js&"
import style0 from "./SpaceSingle.vue?vue&type=style&index=0&id=0808ef56&lang=less&scoped=true&rel=stylesheet%2Fless&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0808ef56",
  null
  
)

export default component.exports